'use strict';
import Component from 'gia/Component';
import gsap from 'gsap';
import {ScrollToPlugin} from '../vendor/gsap-bonus-umd/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);
import easesCustom from '../fx/CustomEases';


export default class VisionView extends Component
{
  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    this.goToHash()
  }

  goToHash()
  {
    if(window.location.hash.length) {
      this.getHash = window.location.hash.replace('#','')
      this.DOM.hash = this.DOM.view.querySelector('#hash-'+this.getHash)
      gsap.to(window,
        {
        duration: 1,
        ease:'quint.out',
        delay:5,
        scrollTo:this.DOM.hash
      });
    }
  }
}
